import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { artiaProtectedApi } from '@/lib/api-client';
import { Pool } from '@/types/pool';

const getPools = async (): Promise<Pool[]> => {
  return await artiaProtectedApi.get('states/pools');
};

export const useGetPools = () => {
  return useQuery({
    queryKey: ['pools'],
    queryFn: async () => getPools()
  });
};

export const useGetPoolsLookups = () => {
  const query = useGetPools();

  const data = useMemo(() => {
    return query.data?.map(pool => ({
      code: pool.code,
      label: pool.name,
      id: pool.id, // Make sure we include id for API calls
      state: pool.states.map(({ code, name }) => ({ code, label: name })),
    }));
  }, [query.data]);

  return {
    ...query,
    data,
  };
};

